const openNewTab = (href: string) => {
  Object.assign(document.createElement("a"), {
    target: "_blank",
    href,
  }).click();
};

export default openNewTab;
